export default __webpack_public_path__ + "static/media/responsive-demo-covid19-tracker.e6662a01.png";